// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-sheet.v-card[data-v-6843bba9]{border-radius:10px}table[data-v-6843bba9]{width:100%}table th[data-v-6843bba9]{word-break:break-word}", ""]);
// Exports
module.exports = exports;
